const moment = require('moment')

export const getDateMinAndMaxFromPeriod = (period) => {
  const today = new Date()
  let limits = {
    dateMin: moment(new Date(today.getFullYear(), today.getMonth(), 1))
      .toDate()
      .toISOString()
      .slice(0, 10),
    dateMax: moment(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59))
      .toDate()
      .toISOString()
      .slice(0, 10),
  }

  switch (period.toString()) {
    case '1': // 'Forrige måned'
      limits = {
        dateMin: moment(new Date(today.getFullYear(), today.getMonth(), 1))
          .subtract(1, 'month')
          .toDate()
          .toISOString()
          .slice(0, 10),
        dateMax: moment(new Date(today.getFullYear(), today.getMonth(), 1))
          .subtract(1, 'seconds')
          .toDate()
          .toISOString()
          .slice(0, 10),
      }

      break
    case '2':
      // "Hittil i år"
      limits = {
        dateMin: moment(new Date(today.getFullYear(), 0, 1)).toDate().toISOString().slice(0, 10),
        dateMax: moment(
          new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
        )
          .toDate()
          .toISOString()
          .slice(0, 10),
      }

      break
    case '3':
      // "I fjor"
      limits = {
        dateMin: moment(new Date(today.getFullYear(), 0, 1))
          .subtract(1, 'year')
          .toDate()
          .toISOString()
          .slice(0, 10),
        dateMax: moment(new Date(today.getFullYear(), 0, 1))
          .subtract(1, 'seconds')
          .toDate()
          .toISOString()
          .slice(0, 10),
      }

      break
    case '0':
    default: {
      // using the default limits
    }
  }

  return limits
}
